import type { IChapter } from '@quesmed/types/models';
import { create } from 'zustand';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

interface ChapterState {
  chapter: IChapter | null;
  preview: boolean;
  chapterId: number;
  conceptId: number;
  updateLoading: boolean;
  reset: () => void;
  setPreview: (val: boolean) => void;
  setChapter: (chapter: IChapter) => void;
  setChapterId: (chapterId: number) => void;
  setUpdateLoading: (loading: boolean) => void;
  setConceptId: (conceptId: number) => void;
}

const initialState: OmitFunctions<ChapterState> = {
  chapterId: 0,
  conceptId: 0,
  updateLoading: false,
  chapter: null,
  preview: false,
};

export const chapterState = create<ChapterState>()((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setPreview: (preview) => set({ preview }),
  setChapter: (chapter) => {
    set({ chapter });
  },
  setChapterId: (chapterId) => set({ chapterId }),
  setUpdateLoading: (loading) => set({ updateLoading: loading }),
  setConceptId: (conceptId) => set({ conceptId }),
}));

export const useChapterState = () => chapterState((state) => state);
export const useChapter = createSelectors(chapterState);
